import React, { Component } from "react";
import AdSense from "react-adsense";
import axios from "axios";
import { connect } from "react-redux";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

import all from "./illustrations/all.png";
import animals from "./illustrations/animals.png";
import people from "./illustrations/people.png";
import fantasy from "./illustrations/fantasy.png";
import horror from "./illustrations/horror.png";
import places from "./illustrations/places.png";
import scifi from "./illustrations/scifi.png";

import paidCategories from "./paidCategories.json";
import { auth, firestore } from "./firebase";
import * as actions from "./store/actions";

import Categories from "./components/Categories/Categories";
import Spinner from "./components/UI/Spinner/Spinner";
import classes from "./App.module.css";
import Modal from "./components/UI/Modal/Modal";
import Description from "./components/Description/Description";
import SignUp from "./components/SignUp/SignUp";
import Purchase from "./components/Purchase/Purchase";
import Account from "./components/Account/Account";
import PasswordReset from "./components/PasswordReset/PasswordReset";
import VerifyEmail from "./components/SignUp/VerifyEmail/VerifyEmail";
import VerifyEmailPurchase from "./components/Purchase/VerifyEmailPurchase/VerifyEmailPurchase";

class App extends Component {
  state = {
    prompts: null,
    categories: [
      { name: "All Prompts", image: all },
      { name: "animals", image: animals },
      { name: "people", image: people },
      { name: "fantasy", image: fantasy },
      { name: "horror", image: horror },
      { name: "places", image: places },
      { name: "sci-fi", image: scifi },
    ],
    currentPrompt: "Click the button to generate your prompt.",
    currentSource: null,
    currentCategory: "All Prompts",
    showModal: false,
    paidCategory: 0,
    mobilePurchase: false,
  };

  componentDidMount() {
    auth.onAuthStateChanged(async (userAuth) => {
      this.props.onAuthUpdateState(userAuth);
      if (userAuth) {
        const userRef = firestore.collection("users").doc(userAuth.uid);
        userRef.get().then((doc) => {
          if (doc.exists) {
            const includeNSFW = doc.data().includeNSFW;
            if (includeNSFW) {
              this.props.onSetIncludeNSFW(includeNSFW);
            }
            const purchased = doc.data().purchased;
            if (
              purchased.includes(paidCategories[this.state.paidCategory].name)
            ) {
              this.setState({
                showModal: false,
                mobilePurchase: false,
              });
            }

            const mailchimpTags = doc.data().mailchimpTags;
            this.props.onSetMailchimpTags(mailchimpTags);
            this.props.onUpdatePurchased(purchased);
            this.processPrompts(purchased);
          } else {
            // Store initial data
            userRef.set({
              email: userAuth.email,
              purchased: [],
              mailchimpTags: [
                { name: "New prompts", status: "inactive" },
                { name: "New features", status: "inactive" },
                { name: "Surveys", status: "inactive" },
              ],
              includeNSFW: false,
            });
            this.processPrompts();
          }
        });
      } else {
        this.processPrompts();
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.purchased !== this.props.purchased) {
      this.processPrompts(this.props.purchased);
    }
  }

  processPrompts = async (purchased = []) => {
    let requestsArray = [axios.get("/app/prompts.json")];
    purchased.map((element) => {
      const filename = element.toLowerCase().replace(/\s/g, "");
      requestsArray.push(axios.get(`/app/${filename}prompts.json`));
      return null;
    });
    const resultsArray = await Promise.all(requestsArray);
    const prompts = [];
    resultsArray.map((response, index) => {
      const promptsData = response.data.prompts.split("^");
      if (response.data.categories) {
        const categoriesData = response.data.categories.split("^");
        for (let i = 0; i < promptsData.length; i++) {
          prompts.push({
            name: promptsData[i],
            category: categoriesData[i],
          });
        }
      } else {
        if (response.data.sources) {
          const sourcesData = response.data.sources.split("^");
          for (let i = 0; i < promptsData.length; i++) {
            prompts.push({
              name: promptsData[i],
              source: sourcesData[i],
              category: purchased[index - 1],
            });
          }
        } else {
          for (let i = 0; i < promptsData.length; i++) {
            prompts.push({
              name: promptsData[i],
              category: purchased[index - 1],
            });
          }
        }
      }
      document.title = `Web Application | Art Prompts | ${prompts.length} drawing prompts`;
      return null;
    });
    this.setState({
      prompts: prompts,
    });
  };

  onNewPromptHandler = () => {
    let prompts = this.state.prompts;
    if (this.props.currentCategory !== "All Prompts") {
      prompts = this.state.prompts.filter((prompt) => {
        return (
          prompt.category.toLowerCase() ===
          this.props.currentCategory.toLowerCase()
        );
      });
    } else if (!this.props.includeNSFW) {
      prompts = this.state.prompts.filter((prompt) => {
        return prompt.category !== "NSFW";
      });
    }
    let promptSelected = false;
    let prompt = null;
    while (!promptSelected) {
      prompt = prompts[Math.floor(Math.random() * prompts.length)];
      promptSelected = prompt.name !== this.state.currentPrompt;
    }
    this.setState({
      currentPrompt: prompt.name,
      currentSource: prompt.source ? prompt.source : null,
    });
  };

  onPaidCategorySelectHandler = (index) => {
    this.setState({ showModal: true, paidCategory: index });
  };

  render() {
    const buttonClasses = classes.Button + " btn btn-primary";
    const theme = createMuiTheme({
      palette: {
        secondary: {
          main: "#FF652F",
        },
      },
    });

    const PurchaseSection = (
      <>
        {this.props.userId && this.props.verified ? (
          <Purchase category={paidCategories[this.state.paidCategory]} />
        ) : this.props.userId ? (
          <VerifyEmailPurchase
            category={paidCategories[this.state.paidCategory]}
          />
        ) : (
          <SignUp />
        )}
      </>
    );

    let content = <Spinner />;
    if (this.state.prompts && !this.state.loading) {
      content = (
        <>
          <Modal
            show={this.state.showModal}
            modalClosed={() =>
              this.setState({ showModal: false, mobilePurchase: false })
            }
          >
            <div className={classes.Left}>
              {this.state.mobilePurchase ? (
                PurchaseSection
              ) : (
                <>
                  <Description
                    category={paidCategories[this.state.paidCategory]}
                  />
                  {window.innerWidth < 768 ? (
                    <button
                      style={{ marginBottom: "32px" }}
                      onClick={() => this.setState({ mobilePurchase: true })}
                    >
                      Purchase
                    </button>
                  ) : null}
                </>
              )}
            </div>
            <div className={classes.Right}>{PurchaseSection}</div>
          </Modal>
          <Modal
            show={this.props.showSettingsModal}
            modalClass={this.props.userId ? null : classes.SignUpModal}
            modalClosed={() => this.props.onSetSettingsModal(false)}
          >
            {this.props.userId && this.props.verified ? (
              <Account selectPaidCategory={this.onPaidCategorySelectHandler} />
            ) : this.props.userId ? (
              <VerifyEmail />
            ) : (
              <SignUp />
            )}
          </Modal>
          <Modal
            show={this.props.showPasswordResetModal}
            modalClosed={() => this.props.setPasswordResetModal(false)}
            modalClass={classes.SmallModal}
          >
            <PasswordReset />
          </Modal>
          <div className={classes.Container}>
            <div>
              <p>
                {this.state.currentPrompt}
                {this.state.currentSource ? (
                  <sup>
                    <a
                      href={this.state.currentSource}
                      target="_blank"
                      rel="noreferrer"
                    >
                      [{">"}]
                    </a>
                  </sup>
                ) : null}
              </p>

              <button
                onClick={this.onNewPromptHandler}
                className={buttonClasses}
              >
                New Prompt
              </button>
              <AdSense.Google
                client="ca-pub-6740228384831244"
                slot="6439514487"
                format="horizontal"
                responsive="false"
              />
            </div>
          </div>
          <Categories
            categories={this.state.categories}
            paidCategories={paidCategories}
            currentCategory={this.props.currentCategory}
            selectCategory={this.props.onSetCurrentCategory}
            selectPaidCategory={this.onPaidCategorySelectHandler}
          />
        </>
      );
    }
    return (
      <ThemeProvider theme={theme}>
        <div className={classes.App}>{content}</div>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  userId: state.userId,
  purchased: state.purchased,
  verified: state.verified,
  showSettingsModal: state.showSettingsModal,
  showPasswordResetModal: state.showPasswordResetModal,
  currentCategory: state.currentCategory,
  includeNSFW: state.includeNSFW,
});

const mapDispatchToProps = (dispatch) => ({
  onAuthUpdateState: (authData) => dispatch(actions.authUpdateState(authData)),
  onUpdatePurchased: (purchased) =>
    dispatch(actions.updatePurchased(purchased)),
  onSetSettingsModal: (show) => dispatch(actions.setSettingsModal(show)),
  setPasswordResetModal: (show) =>
    dispatch(actions.setPasswordResetModal(show)),
  onSetCurrentCategory: (category) =>
    dispatch(actions.setCurrentCategory(category)),
  onSetMailchimpTags: (tags) => dispatch(actions.setMailchimpTags(tags)),
  onSetIncludeNSFW: (include) => dispatch(actions.setIncludeNSFW(include)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
